import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const useRootTranslation = (pattern: string, file?: string) => {
    const translation = useTranslation(file);

    const root = useCallback((
        key:string, 
        options={}
    ): string => {
        return translation.t(`${pattern}.${key}`, options);
    }, [translation, pattern]);

    return { root, ...translation };
}

export default useRootTranslation;
